import BASEURLGESTTOR, { BASEURLGESTTORFORMDATA } from '../api/gesttor'

import { Assinante, atualizarDocumentosPayload, cadastrarDocumentosPayload, paramsListarDocumentos } from '../../interfaces/documentosDigitais'

export function criarDocumentoDigital (payload: cadastrarDocumentosPayload) {
    return BASEURLGESTTORFORMDATA.post(`/documentos`, payload)
}

export function listarDocumentoDigital (params: paramsListarDocumentos) {
    return BASEURLGESTTOR.get(`/documentos?situacao=${params.situacao}&nomeCadastro=${params.nomeCadastro}&pagina=${params.pagina}&dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}&escritorio=${params.escritorio}`)
} 

export function adicionarAssinanteAoDocumentoExistente(idDocumento:string, payload: Assinante) {
    return BASEURLGESTTOR.post(`/documentos/assinantes/${idDocumento}`, payload)
}

export function atualizarDocumento(idDocumento:string, payload: atualizarDocumentosPayload) {
    return BASEURLGESTTOR.patch(`/documentos/${idDocumento}`, payload)
}

export function solicitarAssinaturaWhatsapp(idAssinante: string) {
    return BASEURLGESTTOR.post(`/documentos/assinatura/${idAssinante}`)
}

export function cancelarAssinante(idAssinante: string) {
    return BASEURLGESTTOR.delete(`/documentos/assinatura/${idAssinante}`)
}